import React from "react";

export default function useIsMounted(): () => boolean {
    const didMountRef = React.useRef<boolean>(false);

    React.useEffect(() => {
        didMountRef.current = true;

        return () => {
            didMountRef.current = false;
        };
    }, []);

    return React.useCallback(() => didMountRef.current, []);
}
